import React, { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import {
  CheckboxContainer,
  InputNameContainer,
  NameEditContainer,
  NameInput,
  Quest,
  QuestContainer,
  QuestionAttending,
  QuestionWrapper,
  StyledText,
} from './Attending.styles';
import FormContainer from '../utils/FormContainer/FormContainer';
import Button from '../utils/Button/Button';
import { ReactComponent as CheckBox } from '../../assets/icons/checkbox.svg';
import { ReactComponent as CheckedBox } from '../../assets/icons/checked-icon.svg';

import { useDispatch, useSelector } from 'react-redux';
import {
  selectCreateGuestAnswersPending,
  selectGuestFlow,
  selectInvitationGuestMembers,
  setCurrentGuestIdAndFinished,
  setGuestInformationAnConfirmation,
} from '../../store/slice/rsvp/slice';
import { ReactComponent as Edit } from '../../assets/icons/edit.svg';
import { createGuestAnswers } from '../../store/slice/rsvp/asyncThunks';

const Attending = ({ rsvpKey }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { data } = useSelector(selectInvitationGuestMembers);
  const guestFlow = useSelector(selectGuestFlow);

  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [currentGuest, setCurrentGuest] = useState({});
  const [activeInput, setActiveInput] = useState(false);

  const createGuestAnswersPending = useSelector(selectCreateGuestAnswersPending);

  useEffect(() => {
    if (data.length) {
      const find = data.find(guest => guest.id === data[guestFlow.finished].id);
      if (find) {
        setCurrentGuest(find);
      }
    }
  }, [data, guestFlow.finished]);

  const onContinue = () => {
    if (selectedAnswer === 1) {
      dispatch(
        setGuestInformationAnConfirmation({
          firstName: currentGuest.firstName,
          lastName: currentGuest.lastName,
          id: currentGuest.id,
          confirm: true,
          finished: false,
          email: '',
          phoneNumber: '',
          attendingRehearsalDinner: false,
        }),
      );
      dispatch(
        setCurrentGuestIdAndFinished({
          currentGuestOnFlowId: currentGuest.id,
          finished: 0,
        }),
      );
      const query = { key: rsvpKey, step: 'CONFIRMATION' };
      const queryString = new URLSearchParams(query).toString();
      const url = `/wedding-guest?${queryString}`;

      navigate(url);
    } else {
      const setData = {
        id: currentGuest.guestInvitationId,
        body: {
          guestMembers: [
            {
              firstName: currentGuest.firstName,
              lastName: currentGuest.lastName,
              id: currentGuest.id,
              confirm: false,
              email: '',
              phoneNumber: '',
              attendingRehearsalDinner: false,
            },
          ],
        },
      };
      dispatch(createGuestAnswers(setData))
        .unwrap()
        .then(() => {
          const query = { key: rsvpKey, step: 'SEEYASOON', answer: 'DECLINED' };
          const queryString = new URLSearchParams(query).toString();
          const url = `/wedding-guest?${queryString}`;
          navigate(url);
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  const question = {
    id: 1,
    quest: 'Will you be attending?',
    answers: [
      { id: 1, answer: 'Accept with pleasure' },
      { id: 2, answer: 'Declines with regret' },
    ],
  };

  const handleAnswerClick = answerId => {
    if (selectedAnswer === answerId) {
      setSelectedAnswer(null);
    } else {
      setSelectedAnswer(answerId);
    }
  };

  const handleChangeFirstName = text => {
    setCurrentGuest(guest => {
      return { ...guest, firstName: text };
    });
  };

  const handleChangeLastName = text => {
    setCurrentGuest(guest => {
      return { ...guest, lastName: text };
    });
  };

  return (
    <FormContainer message={'Typo? Please let the couple know how to correctly spell your name!'}>
      <NameEditContainer>
        {!activeInput ? (
          <StyledText>
            {currentGuest ? currentGuest.firstName + ' ' + currentGuest.lastName : 'Name not found'}
          </StyledText>
        ) : (
          <InputNameContainer>
            <NameInput
              placeholder={currentGuest ? currentGuest.firstName : 'Enter guest first name'}
              value={currentGuest && currentGuest.firstName}
              disabled={!activeInput}
              onChange={e => handleChangeFirstName(e.target.value)}
            />
            <NameInput
              placeholder={currentGuest ? currentGuest.lastName : 'Enter currentGuest last name'}
              value={currentGuest && currentGuest.lastName}
              disabled={!activeInput}
              onChange={e => handleChangeLastName(e.target.value)}
            />
          </InputNameContainer>
        )}

        <Edit
          onClick={() => {
            setActiveInput(!activeInput);
          }}
        />
      </NameEditContainer>
      <CheckboxContainer>
        <QuestContainer>
          <Quest>{question.quest}</Quest>
          {question.answers.map(a => (
            <QuestionWrapper key={a.id} onClick={() => handleAnswerClick(a.id)} checked={selectedAnswer === a.id}>
              <QuestionAttending>{a.answer}</QuestionAttending>
              {selectedAnswer === a.id ? <CheckedBox /> : <CheckBox />}
            </QuestionWrapper>
          ))}
        </QuestContainer>
      </CheckboxContainer>

      <Button
        title={'Continue'}
        disabled={!selectedAnswer || createGuestAnswersPending}
        onClick={onContinue}
        width
        loading={createGuestAnswersPending}
      />
    </FormContainer>
  );
};

export default Attending;
